import { Loader2, Play } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { Textarea } from '@/components/ui/textarea'
import { GATE_OPTIONS, SAMPLE_SCHEMAS } from '@/features/admin/schema-playground-data'
import type { ValidationGate } from '@/services/api/schemas'

export function SchemaEditorCard({
  json,
  gate,
  validating,
  onJsonChange,
  onGateChange,
  onValidate,
  onLoadSample,
}: {
  json: string
  gate: ValidationGate | 'all'
  validating: boolean
  onJsonChange: (value: string) => void
  onGateChange: (gate: ValidationGate | 'all') => void
  onValidate: () => void
  onLoadSample: (index: number) => void
}) {
  return (
    <Card className="flex flex-col">
      {/* Below md the header wraps: title and Validate share the first line, the gate select
          takes the full width under them (auto height, its value is two lines). */}
      <CardHeader className="flex flex-row items-center justify-between gap-2 space-y-0 max-md:flex-wrap">
        <CardTitle className="text-base">Schema JSON</CardTitle>
        <div className="flex items-center gap-2 max-md:contents">
          <Select value={gate} onValueChange={v => onGateChange(v as ValidationGate | 'all')}>
            <SelectTrigger className="w-[220px] max-md:order-last max-md:w-full max-md:text-left max-md:data-[size=default]:h-auto">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {GATE_OPTIONS.map(opt => (
                <SelectItem key={opt.value} value={opt.value}>
                  <div className="flex flex-col">
                    <span>{opt.label}</span>
                    <span className="text-muted-foreground text-xs">{opt.description}</span>
                  </div>
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <Button onClick={onValidate} disabled={validating}>
            {validating ? (
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            ) : (
              <Play className="mr-2 h-4 w-4" />
            )}
            Validate
          </Button>
        </div>
      </CardHeader>
      <CardContent className="space-y-3">
        <Textarea
          value={json}
          onChange={e => onJsonChange(e.target.value)}
          className="h-[420px] font-mono text-xs"
          spellCheck={false}
        />
        <div className="flex flex-wrap gap-2">
          {SAMPLE_SCHEMAS.map((sample, idx) => (
            <Button
              key={sample.label}
              variant="outline"
              size="sm"
              className="max-md:h-auto max-md:max-w-full max-md:py-1.5 max-md:text-left max-md:whitespace-normal"
              onClick={() => onLoadSample(idx)}
              title={sample.description}
            >
              {sample.label}
            </Button>
          ))}
        </div>
      </CardContent>
    </Card>
  )
}
